<template>
  <el-container>
    <!-- 顶部 -->
    <el-header>
      <div class="head">
        <div>
          <img class="imgs" :src="logoId" alt="LOGO">
          <span class="title" style="color: #fff;margin-left:10px"><strong>{{title}}</strong></span>
        </div>
        <div>
          <div class="head">
            <span style="margin:0 36px 0 30px;" v-if="isShowBackMap" @click="backToMap()">首页</span>
            <span style="margin:0 36px 0 30px;" @click="goRouter('/show')">前往3g48</span>
            <div style="cursor: pointer;color:#fff;">
              <el-dropdown trigger="click" :hide-on-click="false">
                <span class="el-dropdown-link">
                    <span style="color:#fff;" v-if="userInfo.admin">{{userName}}</span>
                    <span style="color:#fff;" v-else-if="userInfo.organization||userInfo.personal">{{userInfo.name}}</span>
                    <span style="color:#fff;" v-else>{{userName}}({{areaName.name}})</span>
                    <i style="color:#fff;" class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="!userInfo.personal&&!userInfo.organization" @click.native="selfInfo()">个人信息维护</el-dropdown-item>
                  <el-dropdown-item  @click.native="userloginout()">
                    <span>退出</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </el-header>
    <!-- 内容 -->
    <el-container style="height: calc(100% - 60px)">
      <!-- 侧边菜单部分 -->
      <el-aside>
        <el-menu align="left" :default-active="routeAc" router unique-opened class="el-menu-vertical-demo" :collapse="isCollapse">
          <el-submenu v-for="x1 of menu_" :index="x1.id" :key="x1.id" class="my-submenu">
            <template slot="title">
              <div v-if="x1.isPower">
                <i :class="x1.icon"></i>
                <span style="font-size:16px">{{x1.name}}</span>
              </div>
            </template>
            <el-menu-item-group v-for="sub of x1.sub" v-if="sub.isPower" :index="sub.name" :key="sub.name" class="over-hide">
              <template slot="title" v-if="sub.name">
                <div style="padding:7px 0;">
                  <span style="margin-left:10px;">{{sub.name}}</span>
                  <i class="el-icon-d-arrow-right"></i>
                </div>
              </template>
              <template>
                <div v-for="son of sub.son" :key="son.name">
                  <el-menu-item :index="son.name" v-if="son.isPower&&son.type" >
                    <div @click.stop="son.type==='outUrl'?jumpOut(son.name):jumpLocal(son.name)">
                      <span style="margin-left:5px"><i class="el-icon-link"></i>{{son.componentName}}</span>
                    </div>
                  </el-menu-item>
                  <el-menu-item  :index="son.name" v-if="son.isPower&&!son.type" @click="clickMenu(son.name)">
                    <span style="margin-left:5px"><i class="el-icon-link"></i>{{son.componentName}}</span>
                  </el-menu-item>
                </div>
              </template>
              
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
        <div class="collapseBtn" @click="isCollapse=!isCollapse">
          <i class="el-icon-arrow-left" v-if="!isCollapse"></i>
          {{isCollapse?'展开':'收起'}}
          <i class="el-icon-arrow-right" v-if="isCollapse"></i>
        </div>
      </el-aside>
      <!-- 显示数据部分 -->
      <el-main>
        <!-- tab标签部分，使用自定义NavMain组件 -->
        <NavMain />
        <!-- 主体内容部分 -->
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { configMenu } from '../publicData/menuconfig'
import NavMain from '@/components/NavMain'
import { mapMutations } from 'vuex'
export default {
  components: { NavMain },
  data() {
    return {
      menu: configMenu,
      openedTab: [],
      isShowBackMap: false,
      title: '码上-3G48-AI智慧大数据云视频平台',
      // centerDialogVisible:false,
      logoId: require('../assets/logo.png'),
      userName: '管理员',
      areaName: '',
      isCollapse: false,
    }
  },
  computed: {
    routeAc() { return this.$route.name.replace('/', '') },
    menu_() { return this.menu.filter(x => x.isPower) },
  },
  methods: {
    ...mapMutations(['logout']),
    goRouter(str) {
      this.$router.push(str)
    },
    backToMap() {
      this.$router.push('/map3')
    },
    //注销
    userloginout() {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api._user_cancellation().then(res => {
          if (res.data.status === 0) {
            this.logout()
            this.$message.success('注销成功')
            this.$router.push('/login')
          } else { this._status(res.data) }
        })
      }).catch(() => {
        this.$message.info('已取消注销')          
      })
    },
    //获取系统分站设置
    getSetting() {
      this.userName = this.userInfo.aliasName
      if (!this.userInfo.admin) {
        this.getLocalName(this.userInfo.areaId)
        // console.log(this.userInfo.areaId)
        this.$api.getSystem(this.userInfo.areaId).then(res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            // console.log(`%cgetSystem:`, 'color: #00f;', _R)
            sessionStorage.setItem('trainingId', _R.trainingId)
            this.title = _R.title ? _R.title : '码上-3G48-AI智慧大数据云视频平台'
             this.logoId = _R.logoId ? this.puUrl_x + '/' + _R.logoId : require('../assets/logo.png')
            
            // 政策法规
            let item_falvweiquan = this.menu.find(x => x.id === 'falvweiquan')
            _R.policyUrl ? item_falvweiquan.sub[0].son[4].name = _R.policyUrl : ''
            if (item_falvweiquan.sub[0].son[4].name.indexOf('http')) {
              item_falvweiquan.sub[0].son[4].name = `http://${_R.policyUrl}`
            } else {item_falvweiquan.sub[0].son[4].name = _R.policyUrl}

            // 人社业务
            let item_basic3 = this.menu.find(x => x.id === 'basic3')
            _R.socialUrl ? item_basic3.sub[0].son[4].name = _R.socialUrl : ''
            if (item_basic3.sub[0].son[4].name.indexOf('http')) {
              item_basic3.sub[0].son[4].name = `http://${_R.socialUrl}`
            } else {item_basic3.sub[0].son[4].name = _R.socialUrl}
            
          } else { this._status(res.data) }
        })
      } else if (this.userInfo.admin) {
        window.sessionStorage.setItem('trainingId', '')
      }
    },
    //获取地区名
    getLocalName(id) {
      this.$api.get_area_info({areaId: id}).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          this.areaName = _R
        } else { this._status(res.data) }
      })
    },
    //初始化菜单
    setMenu() {
      if (this.userInfo.admin) { // 超级管理员,所有功能都展示
        this.menu.forEach(x1 => {
          this.$set(x1, 'isPower', true)
          x1.sub.forEach(x2 =>{
            this.$set(x2, 'isPower', true)
            x2.son.forEach(x3 => {
              this.$set(x3, 'isPower', true)
            })
          })
        })
        let item_user = this.menu.find(x => x.id === 'user')
        this.$set(item_user, 'isPower', false) // 超管没有账户中心
      } else { // 不是超级管理员,按权限显示的模块
        // 正常情况下，通过权限来渲染菜单
        this.menu.forEach(x1 => {//x1指的是一级菜单
          this.$set(x1, 'isPower', false)//默认不显示，当其下面有子模块显示时改变其值，使显示
          x1.sub.forEach(x2 =>{//x2指的是二级菜单，部分一级菜单没有二级菜单
            this.$set(x2, 'isPower', false)//默认不显示，当其下面有子模块显示时改变其值，使显示
            x2.son.forEach(x3 => {////x3具体的功能模块
              this.$set(x3, 'isPower', false)

              // 如果用户权限列表中存在id对应的模块的增删改查，导入，导出权限，有一个就显示该功能模块,并立即跳出循环
              let arr = [
                x3.id,
                x3.id + '-search',
                x3.id + '-modify',
                x3.id + '-delete',
                x3.id + '-create',
                x3.id + '-import',
                x3.id + '-export',
              ]
              for(let i = 0 ; i < arr.length ; i++) {
                if (this.userInfo.privilegesList.includes(arr[i])) {
                  this.$set(x3, 'isPower', true)
                  x2.isPower = true
                  break
                }
              }

            })
            x2.isPower === true ? x1.isPower = true:'' //一级菜单下有二级菜单可以渲染出来，就让一级菜单渲染
          })
        })
        // 非正常情况，单个判断控制侧边栏的显隐，有些模块依附于一些权限，有些模块根据账号身份显示
        // 判断账号为企业账号个人账号，选择账户中心中的个人模块和企业模块显示与隐藏
        let item_user = this.menu.find(x => x.id === 'user')
        if (this.userInfo.organization === true) {
          this.$set(item_user.sub[0].son[1], 'isPower', true)
          this.$set(item_user.sub[0].son[4], 'isPower', true)
          this.$set(item_user.sub[0].son[5], 'isPower', true)
          this.$set(item_user.sub[0].son[7], 'isPower', true)
          this.$set(item_user.sub[0].son[8], 'isPower', true)
          this.$set(item_user.sub[0].son[9], 'isPower', true)
          this.$set(item_user.sub[0].son[10], 'isPower', true)
        } else if (this.userInfo.personal === true) {
          this.$set(item_user.sub[0].son[0], 'isPower', true)
          this.$set(item_user.sub[0].son[2], 'isPower', true)
          this.$set(item_user.sub[0].son[3], 'isPower', true)
          this.$set(item_user.sub[0].son[8], 'isPower', true)
          this.$set(item_user.sub[0].son[10], 'isPower', true)
        }
        this.$set(item_user, 'isPower', true)
        this.$set(item_user.sub[0], 'isPower', true)
        this.$set(item_user.sub[0].son[6], 'isPower', true)
        // 账号带有的helpLeader属性事判断用户是否为帮扶干部，如果为true就显示 帮扶干部扶贫 模块
        if (this.userInfo.helpLeader) {
          let item_basic2 = this.menu.find(x => x.id === 'basic2')
          this.$set(item_basic2, 'isPower', true)
          this.$set(item_basic2.sub[0], 'isPower', true)
          this.$set(item_basic2.sub[0].son[3], 'isPower', true)
        }
        // 如果个人信息采集模块显示，就让 我的日志模块 显示
        let item_basic = this.menu.find(x => x.id === 'basic')
        if (item_basic.sub[0].son[0].isPower) {
          let item_fupinrizhi = this.menu.find(x => x.id === 'fupinrizhi')
          this.$set(item_fupinrizhi, 'isPower', true)
          this.$set(item_fupinrizhi.sub[0], 'isPower', true)
          this.$set(item_fupinrizhi.sub[0].son[7], 'isPower', true)
        }
        // 如果用户有System-privilege权限设置 的权限 就有角色分配的权限
        if (this.userInfo.privilegesList.includes('System-privilege')) {
          let item_system = this.menu.find(x => x.id === 'system')
          this.$set(item_system.sub[1].son[2], 'isPower', true)
        }
      }
      // 欢迎
      let item_welcome = this.menu.find(x => x.id === 'welcome')
      this.$set(item_welcome, 'isPower', true)
      this.$set(item_welcome.sub[0], 'isPower', true)
      this.$set(item_welcome.sub[0].son[0], 'isPower', true)
      // 政策法规
      let item_xiangcun = this.menu.find(x => x.id === 'xiangcun')
      if (item_xiangcun) {
        this.$set(item_xiangcun, 'isPower', true)
        this.$set(item_xiangcun.sub[0], 'isPower', true)
        this.$set(item_xiangcun.sub[0].son[0], 'isPower', true)
        this.$set(item_xiangcun.sub[0].son[1], 'isPower', true)
      }
      // 政策法规
      let item_falvweiquan = this.menu.find(x => x.id === 'falvweiquan')
      if (item_falvweiquan) {
        this.$set(item_falvweiquan, 'isPower', true)
        this.$set(item_falvweiquan.sub[0], 'isPower', true)
        this.$set(item_falvweiquan.sub[0].son[4], 'isPower', true)
        // 律师
        if (this.userInfo.layer) {
          // let item_falvweiquan = this.menu.find(x => x.id === 'falvweiquan')
          this.$set(item_falvweiquan, 'isPower', true)
          this.$set(item_falvweiquan.sub[0], 'isPower', true)
          this.$set(item_falvweiquan.sub[0].son[3], 'isPower', true)
        }
      }

      // 云讯发布管理系统
      let item_xinxifabu = this.menu.find(x => x.id === 'basic4')
      console.log(`%citem_xinxifabu:`, 'color: #f00;', item_xinxifabu)
      if (item_xinxifabu) {
        this.$set(item_xinxifabu.sub[0].son[0], 'isPower', true)
        this.$set(item_xinxifabu.sub[0], 'isPower', true)
        this.$set(item_xinxifabu, 'isPower', true)
      }

      // 人口进城管理系统
      // let item_questionnaire = this.menu.find(x => x.id === 'basic5')
      // console.log(`%citem_questionnaire:`, 'color: #f00;', item_questionnaire)
      // if (item_questionnaire) {
      //   this.$set(item_questionnaire.sub[0].son[0], 'isPower', true)
      //   this.$set(item_questionnaire.sub[0], 'isPower', true)
      //   this.$set(item_questionnaire, 'isPower', true)
      // }


      // 就业服务管理系统
      let item_jiuyefuwu = this.menu.find(x => x.id === 'work')
      if (item_jiuyefuwu) {
        item_jiuyefuwu.sub[0].son.forEach(son => {
          this.$set(son, 'isPower', true)
        })
        this.$set(item_jiuyefuwu, 'isPower', true)
        this.$set(item_jiuyefuwu.sub[0], 'isPower', true)
      }

      // 工作人员服务系统
      if (this.userInfo.workPerson) {
        let item_gongzuorenyuan = this.menu.find(x => x.id === 'gongzuorenyuan')
        if (item_gongzuorenyuan) {
          this.$set(item_gongzuorenyuan, 'isPower', true)
          this.$set(item_gongzuorenyuan.sub[0], 'isPower', true)
          this.$set(item_gongzuorenyuan.sub[0].son[0], 'isPower', true) // 企业管理
          // this.$set(item_gongzuorenyuan.sub[0].son[1], 'isPower', true) // 发票管理
          this.$set(item_gongzuorenyuan.sub[0].son[2], 'isPower', true) // 送站管理
          this.$set(item_gongzuorenyuan.sub[0].son[3], 'isPower', true) // 接站管理
        }
      }

      // 交流投诉服务系统
      if (this.userInfo.organization) {
        let item_complaint = this.menu.find(x => x.id === 'complaint')
        if (item_complaint) {
          this.$set(item_complaint, 'isPower', true)
          this.$set(item_complaint.sub[0], 'isPower', true)
          this.$set(item_complaint.sub[0].son[0], 'isPower', true) // 交流管理
          // this.$set(item_complaint.sub[0].son[1], 'isPower', true) // 投诉管理
        }
      }

      // 个人社保服务系统
      if (this.userInfo.personal) {
        let item_gerenshebao = this.menu.find(x => x.id === 'shebao')
        if (item_gerenshebao) {
          this.$set(item_gerenshebao, 'isPower', true)
          this.$set(item_gerenshebao.sub[0], 'isPower', true)
          // this.$set(item_gerenshebao.sub[0].son[0], 'isPower', true) // 个人社保信息管理
          // this.$set(item_gerenshebao.sub[0].son[1], 'isPower', true) // 未转移社保名单
          // this.$set(item_gerenshebao.sub[0].son[2], 'isPower', true) // 社保补缴费管理
          this.$set(item_gerenshebao.sub[0].son[3], 'isPower', true) // 缴纳情况查询
        }
      }

      // 建筑工地管理系统
      let item_jzgd = this.menu.find(x => x.id === 'jzgd')
      if (item_jzgd) {
        this.$set(item_jzgd, 'isPower', true)
        this.$set(item_jzgd.sub[0], 'isPower', true)
        this.$set(item_jzgd.sub[0].son[0], 'isPower', true) // 在线求助
      }

      // 法律援助管理系统
      // let item_falvyuanzhu = this.menu.find(x => x.id === 'falvyuanzhu')
      // if (item_falvyuanzhu) {
        // this.$set(item_falvyuanzhu, 'isPower', true)
        // this.$set(item_falvyuanzhu.sub[0], 'isPower', true)
        // this.$set(item_falvyuanzhu.sub[0].son[0], 'isPower', true)
      // }
    },
    //链接跳转
    jumpOut(url) {
      window.open(url)
    },
    jumpLocal(url) {
      this.$router.push(url)
    },
    //返回首页
    back() {
      this.$router.push('/map')
    },
    //个人信息
    selfInfo() {
      this.$router.push('/selfinfo')
      this.clickMenu('selfinfo')
    },
  },
  created() {
    this.isShowBackMap = false
    if (this.userInfo.admin) {
      this.isShowBackMap = true
    } else {
      // console.log(this.userInfo.privilegesList.indexOf("System-query-map")!=-1)
      this.userInfo.privilegesList.includes('System-query-map')? this.isShowBackMap = true : ''
    }
  },
  mounted() {
    this.setMenu()
    this.userInfo.mustModifyPassword ? this.getLocalName(this.userInfo.areaId) : this.getSetting()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.userInfo == null) {
        vm.$confirm('检测到还未登录, 是否跳转到登录页面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vm.$router.push('/login')
        }).catch(() => {
          vm.$router.push('/login')
        })
      } else {
        if (to.params.info) {
          vm.$store.commit('addTab', to.name)
        } else if (vm.$route.name !== 'welcome') {
          vm.$store.commit('addTab', vm.$route.name)
        }
      }
    })
  },
}
</script>

<style lang='scss' scoped>
.collapseBtn{
  width:60px;height:30px;line-height:30px;text-align: center;
  background:#409EFF;color:#fff;font-size: 14px;
  border-radius: 0 6px 6px 0;position: absolute;bottom: 4px;
}

.el-container {height: 100%;min-width: 1240px;background: #fff;}

.el-header {color: #FFF;background: #1E9FFF;}

.el-aside {
  width: auto!important;color: #333;height: 100%;
  border-right: 1px solid rgb(246, 246, 246);background: #fff;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {width: 200px;min-height: 400px;}

.el-main {color: #333;height: 100%;padding: 0 !important;background: #fff;}
.el-menu {border: none !important;padding-bottom: 180px;}
.el-breadcrumb {background: rgb(148, 205, 234);padding: 8px 0 8px 8px;}
.el-breadcrumb>span .el-breadcrumb__separator {color: black;}
body>.el-container {margin-bottom: 40px;}
.head {display: flex;justify-content: space-between;align-items: center;}
.head>div {height: 60px;line-height: 58px;}
.head>span {margin: 0 15px 0 15px;}
.head>span:hover {color: rgb(100, 174, 248);cursor: pointer;}
.avator {width: 36px;height: 36px;border-radius: 50%;}
.imgs {height: 100%;}
.head .title, .imgs {display: inline-block;vertical-align: middle;font-size: 24px;letter-spacing: 1px;color: rgb(100, 174, 248);}
/deep/.el-menu-item-group__title {padding: 0 0 0 40px;}
</style>